import { render, staticRenderFns } from "./logDialog.vue?vue&type=template&id=5c50e58c&lang=pug"
import script from "./logDialog.vue?vue&type=script&lang=js"
export * from "./logDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports